export const hcExtra = {
  reservas: {
    buscar: "Cerca",
    limpiar: "Pulisci",
    todas: "Tutti",
  },
  nav: {
    volver: "Indietro",
  },
  listingDetail: {
    badgeNew: "Nuovo",
  },
  ofertas: {
    precio: "Prezzo",
  },
  payService: {
    sendRequest: "Invia richiesta",
  },
  accountCfg: {
    accountEmail: "Email dell'account",
  },
};
